// import { useState } from "react";
// import { motion } from "framer-motion";
import FadeInWhenVisible from "../components/Fade";
import FadeLeftWhenVisible from "../components/Fadeleft";
import FadeRightWhenVisible from "../components/Faderight";
import aboutimage from "../assets/support.png";
// import Modal from "./Modal";

function About() {
  // const [showModal, setShowModal] = useState(false);
  // const openModal = () => {
  //   setShowModal((prev) => !prev);
  // };
  return (
    <section id="about">
      <FadeInWhenVisible>
        <article className=" service-text flex flex-col justify-center items-center text-center">
          <p className="sv pb-2">About Us</p>
          <h2 className="text-2xl font-bold">How We Make It Personal</h2>
          <h2 className="text-sm tracking-tight">Your Mobile, Your Way</h2>
        </article>
      </FadeInWhenVisible>
      <article className="about md:grid md:gap-8 md:grid-cols-2 grid">
        <FadeLeftWhenVisible>
          <div className="about-image">
            <img
              src={aboutimage}
              className="about-img"
              alt="support team working together illustration"
            />
          </div>
        </FadeLeftWhenVisible>
        {/* {!showModal && ( */}
          <FadeRightWhenVisible>
            <article className="about-text">
              <h4>
                <strong> 247 Comcare, </strong>operates at the intersection of telecommunications infrastructure and digital entertainment.
              </h4>
              <br />
              <div className=" ">
                <p>We partner with network operators and digital service providers to deploy revenue-generating services across SMS, USSD, IVR, carrier billing, and CRBT ecosystems. Our focus is long-term, sustainable monetization supported by strong compliance and operational discipline</p>
              </div>

              {/* <motion.button
                whileHover={{ scale: 1.1 }}
                className="abtn btn mb-6"
                onClick={openModal}
              >
                Learn More About Us
              </motion.button> */}
            </article>
          </FadeRightWhenVisible>
        {/* )}
        {showModal ? <Modal openModal={openModal} /> : null} */}
      </article>
      <section className="flex"></section>
    </section>
  );
}
export default About;
